/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedItemTile_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedItemTile_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
